export const createApiCase = (builder, thunk, { loading, fulfilled }) => {
    builder
        .addCase(thunk.pending, (state) => {
            state[loading] = true
        })
        .addCase(thunk.fulfilled, (state, action) => {
            state[loading] = false
            if (fulfilled) {
                fulfilled(state, action)
            }
        })
        .addCase(thunk.rejected, (state) => {
            state[loading] = false
        })
}
